<main class="main main-with-bg" role="main" id="main" tabindex="-1">
    <div class="container">

        <div class="row justify-content-center">
            <div class="col-md-10 col-lg-8">
                <div class="text-center">
                    <h1>{{ 'home.title' | translate }}</h1>
                    <p class="lead">{{ 'home.subtitle' | translate }}</p>
                    <h1 class="h3 mt-5 mb-3">{{ 'home.souhait' | translate }}</h1>
                </div>
                <app-loader></app-loader>
            </div>
        </div>

        <div class="row justify-content-center">

            <!-- CERTIFICATS LOGICIELS -->
            <div *ngIf="getPermissions('CL') && (autorisations?.includes('CONSULTATION_CL') ||
                                                 autorisations?.includes('CREATION_CL') ||
                                                 autorisations?.includes('CREATION_CL_PM') ||
                                                 autorisations?.includes('CREATION_DELEGUE'))"
                 class="col-12 col-md-4 d-flex" >
                <div class="border rounded-md top-left-radius-0 bg-white p-3 mb-3 text-center w-100">
                    <img src="../../../assets/img/icons-illustratives/Certificats_logiciels.svg"
                        alt="Certificats logiciels" width="120" height="120" loading="lazy" />
                    <h3 class="h5">
                        {{ 'home.cl.title' | translate }}
                        <app-infobulle [title]="'infobulles.home.administrateurTechnique' | translate"></app-infobulle>
                    </h3>
                    <p>{{ 'home.cl.subtitle' | translate }}</p>
                    <ul class="text-left">
                        <li *ngIf="autorisations?.includes('CONSULTATION_CL')" class="mb-1">
                            <a #gererHabilitationLink class="btn--icon-before" [routerLink]="['/habilitation/gestion/cl']">
                                <svg class="svg-icon svg-angle-right" aria-hidden="true" focusable="false"><use xlink:href="../../../assets/svg-icons/icon-sprite.svg#angle-right"></use></svg>
                                {{ 'home.gerer' | translate }}
                            </a>
                        </li>
                        <li *ngIf="autorisations?.includes('CREATION_CL')" class="mb-1">
                            <a class="btn--icon-before" [routerLink]="['/habilitation/cl']">
                                <svg class="svg-icon svg-angle-right" aria-hidden="true" focusable="false"><use xlink:href="../../../assets/svg-icons/icon-sprite.svg#angle-right"></use></svg>
                                {{ 'home.ajouter' | translate }}
                            </a>
                        </li>
                        <li *ngIf="(canCreateDelegueTier || canCreateCLTier) && (autorisations?.includes('CREATION_DELEGUE_PM') || autorisations?.includes('CREATION_CL_PM'))" class="mb-1">
                            <svg class="svg-icon svg-angle-right" aria-hidden="true" focusable="false"><use xlink:href="../../../assets/svg-icons/icon-sprite.svg#angle-right"></use></svg>
                            <button
                                class="btn-link dropdown-toggle"
                                data-toggle="dropdown"
                                aria-expanded="false"
                                aria-controls="multiCollapseCL"
                                (click)="toggleMenuDeleguerAUnTiers()">
                                {{ 'home.designer' | translate }}
                            </button>
                            <ul #menuDeleguerAUnTiers id="multiCollapseCL" class="dropdown-menu subMenu" [ngClass]="{show: hasToShowMenuDeleguerAUnTiers}">
                                <li *ngIf="autorisations?.includes('CREATION_DELEGUE_PM') && canCreateDelegueTier">
                                    <a class="btn--icon-before" [routerLink]="['/habilitation/delegue-structure']">
                                        <svg class="svg-icon svg-angle-right" aria-hidden="true" focusable="false"><use xlink:href="assets/svg-icons/icon-sprite.svg#angle-right"></use></svg>
                                        {{ 'home.cl.delegueMenu.designerDelegueTiers' | translate }}
                                    </a>
                                </li>
                                <li *ngIf="autorisations?.includes('CREATION_CL_PM') && canCreateCLTier">
                                    <a class="btn--icon-before" [routerLink]="['/habilitation/cl-structure']">
                                        <svg class="svg-icon svg-angle-right" aria-hidden="true" focusable="false"><use xlink:href="assets/svg-icons/icon-sprite.svg#angle-right"></use></svg>
                                        {{ 'home.cl.delegueMenu.designerAdministrateurTiers' | translate }}
                                    </a>
                                </li>
                            </ul>
                            <app-infobulle class="ml-1" [title]="'infobulles.home.delegues' | translate"></app-infobulle>
                        </li>
                    </ul>
                </div>
            </div>

            <!-- GESTIONNAIRE RPPS+  -->
            <div *ngIf="getPermissions('GARS') && (autorisations?.includes('CREATION_ARS') || autorisations?.includes('CONSULTATION_ARS'))" class="col-12 col-md-4 d-flex">
                <div class="border rounded-md top-left-radius-0 bg-white p-3 mb-3 text-center w-100">
                    <img src="../../../assets/img/icons-illustratives/Habilitations-gestionnaires.svg" alt="Habilitations gestionnaires" width="120" height="120" loading="lazy" />
                    <h3 class="h5">
                        {{ 'home.gars.title' | translate }}
                        <app-infobulle [title]="'infobulles.home.gestionnaireGARS' | translate"></app-infobulle>
                    </h3>
                    <p>{{ 'home.gars.subtitle' | translate }}</p>
                    <ul class="text-left">
                        <li *ngIf="autorisations?.includes('CONSULTATION_ARS')" class="mb-1">
                            <a class="btn--icon-before" [routerLink]="['/habilitation/gestion/gars']">
                                <svg class="svg-icon svg-angle-right" aria-hidden="true" focusable="false"><use xlink:href="assets/svg-icons/icon-sprite.svg#angle-right"></use></svg>
                                {{ 'home.gerer' | translate }}
                            </a>
                        </li>
                        <li *ngIf="autorisations?.includes('CREATION_ARS')" class="mb-1">
                            <a class="btn--icon-before" [routerLink]="['/habilitation/gars']">
                                <svg class="svg-icon svg-angle-right" aria-hidden="true" focusable="false"><use xlink:href="assets/svg-icons/icon-sprite.svg#angle-right"></use></svg>
                                {{ 'home.ajouter' | translate }}
                            </a>
                        </li>
                    </ul>
                </div>
            </div>

            <!-- ETABLISSEMENT SANTE -->
            <div *ngIf="getPermissions('GAE') && (autorisations?.includes('CREATION_RPPS') || autorisations?.includes('CONSULTATION_RPPS'))" class="col-12 col-md-4 d-flex">
                <div class="border rounded-md top-left-radius-0 bg-white p-3 mb-3 text-center w-100">
                    <img src="../../../assets/img/icons-illustratives/Etablissements_sante.svg" alt="Etablissements sante" width="120" height="120" loading="lazy" />
                    <h3 class="h5">
                        {{ 'home.gae.title' | translate }}
                        <app-infobulle [title]="'infobulles.home.gestionnaireGAE' | translate"></app-infobulle>
                    </h3>
                    <p>{{ 'home.gae.subtitle' | translate }}</p>
                    <ul class="text-left">
                        <li class="mb-1" *ngIf="autorisations?.includes('CONSULTATION_RPPS')">
                            <a class="btn--icon-before" [routerLink]="['/habilitation/gestion/gae']">
                                <svg class="svg-icon svg-angle-right" aria-hidden="true" focusable="false"><use xlink:href="assets/svg-icons/icon-sprite.svg#angle-right"></use></svg>
                                {{ 'home.gerer' | translate }}
                            </a>
                        </li>
                        <li class="mb-1" *ngIf="autorisations?.includes('CREATION_RPPS')">
                            <a class="btn--icon-before" [routerLink]="['/habilitation/gae']">
                                <svg class="svg-icon svg-angle-right" aria-hidden="true" focusable="false"><use xlink:href="assets/svg-icons/icon-sprite.svg#angle-right"></use></svg>
                                {{ 'home.ajouter' | translate }}
                            </a>
                        </li>
                    </ul>
                </div>
            </div>

            <!-- HABILITATIONS DE VOS COLLABORATEURS -->
            <div *ngIf="canHandleCollaborateurs" class="col-12 col-md-4 d-flex">
                <div class="border rounded-md top-left-radius-0 bg-white p-3 mb-3 text-center w-100">
                    <img src="../../../assets/img/icons-illustratives/Autres_Ressources_humaines.svg" alt="Habilitations collaborateurs" width="120" height="120" loading="lazy" />
                    <h3 class="h5">
                        {{ 'home.collaborateurs.title' | translate }}
                        <app-infobulle [title]="'infobulles.home.collaborateurs' | translate"></app-infobulle>
                    </h3>
                    <p>{{ 'home.collaborateurs.subtitle' | translate }}</p>
                    <ul class="text-left">
                        <li *ngIf="autorisations?.includes('CONSULTATION_COLLABORATEUR')" class="mb-1" >
                            <svg class="svg-icon svg-angle-right" aria-hidden="true" focusable="false"><use xlink:href="../../../assets/svg-icons/icon-sprite.svg#angle-right"></use></svg>
                            <button
                                class="btn-link dropdown-toggle"
                                data-toggle="dropdown"
                                aria-expanded="false"
                                aria-controls="multiCollapseCollaborateurGerer"
                                (click)="toggleMenuGererCollaborateur()">{{ 'home.gerer' | translate }}
                            </button>

                            <ul #menuGestion id="multiCollapseCollaborateurGerer" class="dropdown-menu subMenu" [ngClass]="{show: hasToShowMenuGererCollaborateur}" style="margin-top: -20px;">
                                <li *ngIf="autorisations?.includes('CONSULTATION_DELEGUE_GENERIQUE')">
                                    <a class="btn--icon-before" [routerLink]="['/habilitation/gestion/delegue-generique']">
                                        <svg class="svg-icon svg-angle-right" aria-hidden="true" focusable="false"><use xlink:href="assets/svg-icons/icon-sprite.svg#angle-right"></use></svg>
                                        {{ 'home.collaborateurs.delegue-generique.gerer' | translate }}
                                    </a>
                                </li>
                                <li *ngIf="autorisations?.includes('CONSULTATION_ADMIN_GENERIQUE')">
                                    <a class="btn--icon-before" [routerLink]="['/habilitation/gestion/admin-generique']">
                                        <svg class="svg-icon svg-angle-right" aria-hidden="true" focusable="false"><use xlink:href="assets/svg-icons/icon-sprite.svg#angle-right"></use></svg>
                                        {{ 'home.collaborateurs.admin-generique.gerer' | translate }}
                                    </a>
                                </li>
                            </ul>
                        </li>
                        <li *ngIf="autorisations?.includes('CREATION_COLLABORATEUR')" class="mb-1" >
                            <svg class="svg-icon svg-angle-right" aria-hidden="true" focusable="false"><use xlink:href="../../../assets/svg-icons/icon-sprite.svg#angle-right"></use></svg>
                            <button
                                class="btn-link dropdown-toggle"
                                data-toggle="dropdown"
                                aria-expanded="false"
                                aria-controls="multiCollapseCollaborateurAjouter"
                                (click)="toggleMenuAjouterCollaborateur()">{{ 'home.ajouter' | translate }}
                            </button>

                            <ul #menuAjout id="multiCollapseCollaborateurAjouter" class="dropdown-menu subMenu" [ngClass]="{show: hasToShowMenuAjouterCollaborateur}">
                                <li *ngIf="autorisations?.includes('CREATION_DELEGUE_GENERIQUE')">
                                    <a class="btn--icon-before" [routerLink]="['/habilitation/delegue-generique']">
                                        <svg class="svg-icon svg-angle-right" aria-hidden="true" focusable="false"><use xlink:href="assets/svg-icons/icon-sprite.svg#angle-right"></use></svg>
                                        {{ 'home.collaborateurs.delegue-generique.ajouter' | translate }}
                                    </a>
                                </li>
                                <li *ngIf="autorisations?.includes('CREATION_ADMIN_GENERIQUE')">
                                    <a class="btn--icon-before" [routerLink]="['/habilitation/admin-generique']">
                                        <svg class="svg-icon svg-angle-right" aria-hidden="true" focusable="false"><use xlink:href="assets/svg-icons/icon-sprite.svg#angle-right"></use></svg>
                                        {{ 'home.collaborateurs.admin-generique.ajouter' | translate }}
                                    </a>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>

        </div>

    </div>
</main>
